// Library Methods
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Styles
import {
  PageContainerWrapper,
  getSurfaceTokens,
  getEmrPageBackground,
} from "src/styles/mui/muiStylesHelper";

// Components
import Box from "@mui/material/Box";
import EmrIntegration from "./EmrIntegration/EmrIntegration";
import ImportedEMRs from "src/components/containers/EMR/ImportedEMRs/ImportedEMRs";
import SharedTabs from "src/components/shared/navigation/SharedTabs/SharedTabs";
import SnackbarMessage from "src/components/shared/alerts/SnackbarMessage/SnackbarMessage";

// Styles
import { useTheme } from "@mui/material/styles";

// Contexts
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

const Emr = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const { snackbarInfo, setSnackbarInfo } = useSnackbarContext();
  const { clinicInfo, isLoading } = useClinicContext();

  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = useMemo(
    () => [
      { id: 0, label: t("Data Hub Config"), showTab: true },
      {
        id: 1,
        label: t("Processed Exams"),
        showTab: true,
      },
    ],
    [t]
  );

  const canUseEMR = useMemo(
    () => clinicInfo?.licensing?.canUseEMR && !isLoading,
    [clinicInfo?.licensing?.canUseEMR, isLoading]
  );

  const isClinicReady = Boolean(clinicInfo?.id) && !isLoading;

  useEffect(() => {
    if (isClinicReady && !canUseEMR) {
      navigate("/dashboard");
    }
  }, [navigate, canUseEMR, isClinicReady]);

  return (
    <Box
      sx={{
        ...PageContainerWrapper(theme),
        background: getEmrPageBackground(theme),
        color: getSurfaceTokens(theme).onSurface,
        padding: "0px",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          maxHeight: "fit-content",
          gap: "16px",
          padding: "16px",
        }}
      >
        <SharedTabs
          tabs={tabs}
          selectedTabId={selectedTab}
          onChange={(tabId) => setSelectedTab(tabId)}
          tabColor="#1B8F76"
        />
        {selectedTab === 0 && <EmrIntegration />}
        {selectedTab === 1 && <ImportedEMRs />}

        {/* Snackbar success and error messages */}
        <SnackbarMessage
          snackbarInfo={snackbarInfo}
          setSnackbarInfo={setSnackbarInfo}
        />
      </Box>
    </Box>
  );
};

export default Emr;
